<template>
    <div v-if="category" :class="{'category-pill': true, white: color === 'white', selected: selected}">
        <UncrawlableLink v-if="button" to="#" @click="onclick">
            <span>{{ label }}</span>
        </UncrawlableLink>
        <UncrawlableLink v-else :to="$withLocalePrefix(link ?? `/resources/search?category=${category}`)" external>
            <span>{{ label }}</span>
        </UncrawlableLink>
    </div>
</template>

<script lang="ts" setup>
    import {UncrawlableLink} from '#components';
    import {ref, useTranslation} from '#imports';

    const props = defineProps<{
        category: string;
        color?: 'primary' | 'white';
        label?: string;
        link?: string;
        button?: boolean;
        selected?: boolean;
        onclick?: () => void;
    }>();

    const {t} = useTranslation();

    const label = ref<string>(props.label || t(`resources.categories.${props.category}` as any));
</script>

<style lang="scss">
    .category-pill {
        padding: 4px 12px;

        a,
        button {
            display: inline-block;
            color: var(--joy-color-primary-50);
            font-size: var(--joy-font-size-primary-400);
            text-align: center;
            transition: color var(--joy-transition-duration-default) var(--joy-transition-timing-function);
            position: relative;
            background: transparent;

            span {
                position: relative;
                z-index: 2;
            }

            &::after {
                border: 1px solid var(--joy-color-primary-50);
                border-radius: 50px;
                background-color: var(--joy-color-background-default);
                content: '';
                z-index: 1;
                position: absolute;
                inset: -4px -12px;
                transition: background-color var(--joy-transition-duration-default) var(--joy-transition-timing-function);
            }

            &:hover {
                color: var(--joy-color-neutral-0);

                &::after {
                    background-color: var(--joy-color-primary-50);
                }
            }
        }

        &.selected {
            a,
            button {
                color: var(--joy-color-neutral-0);

                &::after {
                    background-color: var(--joy-color-primary-50);
                }

                &:hover::after {
                    background-color: var(--joy-color-primary-70);
                }
            }
        }

        &.white {
            a,
            button {
                color: var(--joy-color-neutral-0);

                &::after {
                    border: 1px solid var(--joy-color-neutral-0);
                    background-color: var(--joy-color-primary-50);
                }

                &:hover {
                    color: var(--joy-color-primary-50);

                    &::after {
                        background-color: var(--joy-color-background-default);
                    }
                }

                &.selected::after {
                    background-color: var(--joy-color-neutral-30);
                }
            }
        }
    }
</style>
